import {API} from 'common/api';
import type {Sale} from './types';

export const getActiveSale = async (): Promise<Sale | null> => {
  const response = await API.get('/v1/sales/active');
  return response as Sale | null;
};
